import React from 'react';
import { number } from 'prop-types';
import { CircularProgress } from '@material-ui/core';

import styles from './styles.scss';

const Loader = ({ size }) => (
  <div className={styles.wrapper}>
    <CircularProgress size={size} />
  </div>
);

Loader.propTypes = {
  size: number.isRequired,
};

Loader.defaultProps = {
  size: 40,
};

export default Loader;
